import _extends from "@babel/runtime/helpers/extends";
import { Checkbox, LinkToggle, useBanner, BannerCookie, useGroupCheckbox } from "../../..";
import { Group } from "../../common";
const BannerGroup = _ref => {
  let {
    group
  } = _ref;
  const banner = useBanner();
  const {
    name,
    description,
    items
  } = group;
  const {
    group: {
      headlineFontSize
    },
    individualTexts: {
      headline,
      showMore,
      hideMore
    }
  } = banner;
  const groupCheckbox = useGroupCheckbox(group);
  return h(Group, {
    legend: `${headline}: ${name}`,
    headline: h(Checkbox, _extends({}, groupCheckbox, {
      fontSize: headlineFontSize
    }), name, " (", items.length, ")")
  }, h("span", null, description), !!items && h(LinkToggle, {
    showMore: showMore,
    hideMore: hideMore
  }, items.map(cookie => h(BannerCookie, {
    key: cookie.id,
    group: group,
    cookie: cookie
  }))));
};
export { BannerGroup };